const icons = {
    'vinda:index': {
        type:'icon',
        url: 'el-icon-s-home'
    },
    'vinda:sysCfg': {
        type:'icon',
        url: 'el-icon-s-tools'
    },
    'vinda:role': {
        type:'icon',
        url: 'el-icon-unlock'
    },
    'vinda:myAppraise': {
        type: 'icon',
        url: 'el-icon-s-marketing'
    },
    'vinda:appraise': {
        type: 'icon',
        url: 'el-icon-s-marketing'
    },
    'vinda:rank': {
        type: 'icon',
        url: 'el-icon-s-data'
    },
    'vinda:teamAppraise': {
        type: 'image',
        svg: `<path d="M1024.244053 733.013333c0 46.933333-20.906667 55.701333-97.92 56.064-20.693333-182.037333-118.4-271.765333-222.933333-314.496a244.565333 244.565333 0 0 0 6.186667-299.029333 149.226667 149.226667 0 0 1 97.92 280.874667A281.344 281.344 0 0 1 1024.244053 733.013333zM603.124053 489.28C727.924053 513.557333 874.91072 596.181333 874.91072 832c0 64-85.12 64-362.666667 64-278.613333 0-362.666667 0.661333-362.666666-64 0-235.242667 146.56-318.293333 271.786666-342.72a192 192 0 1 1 181.76 0zM320.457387 473.6C216.564053 517.354667 119.07072 609.322667 98.377387 789.333333 20.937387 789.162667 0.244053 780.650667 0.244053 733.12a271.722667 271.722667 0 0 1 215.466667-277.333333A149.141333 149.141333 0 0 1 314.91072 175.573333a244.288 244.288 0 0 0 5.546667 298.026667z" p-id="2330" fill='#999999'></path>`
    },
    'vinda:report': {
        type: 'image',
        svg: `<path d="M490.666667 128A405.290667 405.290667 0 0 0 85.333333 533.333333c0 223.914667 181.418667 405.333333 405.333334 405.333334s405.333333-181.418667 405.333333-405.333334h-405.333333V128z" p-id="1863" fill="#949aaf"></path><path d="M554.666667 85.333333v384h384c1.834667-212.096-170.069333-384-384-384z" p-id="1864" fill="#949aaf"></path>`
    }
}

export default icons;